var map = {
	"./logo_chatdesk.svg": 216,
	"./logo_customerio.svg": 517,
	"./logo_facebook.svg": 272,
	"./logo_freshdesk.svg": 340,
	"./logo_frontapp.svg": 341,
	"./logo_gladly.svg": 342,
	"./logo_gorgias.svg": 343,
	"./logo_helpscout.svg": 344,
	"./logo_instagram.svg": 273,
	"./logo_kustomer.svg": 345,
	"./logo_salesforce.svg": 518,
	"./logo_shopify.svg": 274,
	"./logo_tiktok.svg": 275,
	"./logo_tiktokads.svg": 519,
	"./logo_trustpilot.svg": 520,
	"./logo_twitter.svg": 346,
	"./logo_whistle.svg": 347,
	"./logo_youtube.svg": 521,
	"./logo_zendesk.svg": 217
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2115;